import React from "react";
import { Mission2 } from "../Types";

export type SettingsTypeToClassMapping = {
    [type: string]: {
        clazz: any,
        createReactElement?: boolean
    }
}

export function transformMissionWorkflowFromSettingsToReactNodes(mapping: SettingsTypeToClassMapping, node: { type: string, [key: string]: any } | {}, initialPropsForChild?: {[key: string]: any }, isObjectStates?: boolean) {
    if (!("type" in node)) {
        throw new Error("Trying to convert a node w/o the field 'type'.");
    }
    const m = mapping[node.type];
    if (!m) {
        throw new Error("Trying to convert a node w/ type = " + node.type + ". But there is no mapping for it.")
    }
    let propertiesHolder = m.createReactElement ? {} : new m.clazz();

    for (const key in node) {
        if (key === "type") {
            continue;
        }
        const child = node[key];

        if (Array.isArray(child)) {
            if (child.every(item => typeof item === "object")) {
                propertiesHolder[key] = child.map((c, i) => transformMissionWorkflowFromSettingsToReactNodes(mapping, c, { key: i }, key === "objectStates"));
            } else {
                propertiesHolder[key] = child
            }
        } else if (typeof child === "object") {
            if (child) {
                propertiesHolder[key] = transformMissionWorkflowFromSettingsToReactNodes(mapping, child, undefined, key === "objectStates");
            }
        } else {
            propertiesHolder[key] = child;
        }
    }

    if (isObjectStates) {
        propertiesHolder["taskMode"] = true;
    }

    Object.assign(propertiesHolder, initialPropsForChild);

    if (m.createReactElement) {
        return React.createElement(m.clazz, propertiesHolder);
    } else {
        return propertiesHolder;
    }
}